import { onBeforeUnmount, toValue, watch } from 'vue'
import type { MaybeRefOrGetter } from 'vue'

import { useBubbleStore } from '@app/application/communication/store/bubbles'

type BubbleRegistration =
  | { type: 'input'; path: MaybeRefOrGetter<string> }
  | {
      type: 'remark'
      path: MaybeRefOrGetter<string | null>
      id: MaybeRefOrGetter<string>
      preventUnlink?: MaybeRefOrGetter<boolean | undefined>
    }

export default (registration: BubbleRegistration): void => {
  const bubbleStore = useBubbleStore()

  const unregister = (path: string | null | undefined): void => {
    if (!path) {
      return
    }

    if (registration.type === 'remark' && toValue(registration.preventUnlink)) {
      return
    }

    bubbleStore.unregisterBubble(registration.type, path)
  }

  // Deleting the row a note was written on clears its path while the card
  // stays mounted, so the old path has to go or the next input on it pairs up.
  watch(
    () => toValue(registration.path),
    (path, previousPath) => {
      unregister(previousPath)

      if (!path) {
        return
      }

      if (registration.type === 'input') {
        bubbleStore.registerBubble('input', { linkingPath: path })
      } else {
        bubbleStore.registerBubble('remark', {
          id: toValue(registration.id),
          linkingPath: path,
        })
      }
    },
    { immediate: true }
  )

  onBeforeUnmount(() => unregister(toValue(registration.path)))
}
